import React, {useState} from 'react';
import DesignCardList from "./design-card-list";
import {PlusCircleIcon} from "@heroicons/react/24/solid";

const DesignDashboard = () => {
    const [designsCount, setDesignsCount] = useState(0);

    return (
        <>

            <div className="page-container-background design-dashboard-container">

                <div className="items-center justify-start p-8 mb-28 w-full">
                    <div className="flex justify-start items-center m-2 pb-2 -mt-1">
                        <div className="text-xl">
                            Designs <span className="text-purple-600 ml-1 font-bold">({designsCount})</span>
                        </div>

                        <div className="ml-4">
                            <a className="cursor-pointer"
                               href="/designs/add">
                                <div className="">
                                    <PlusCircleIcon className="h-10 w-10"/>
                                </div>
                            </a>
                        </div>

                        <div className="ml-4">
                            <a className="button-green px-3 py-2"
                               href="/designs/multi-products-designer">
                                Multi Products Designer
                            </a>
                        </div>
                    </div>

                    <DesignCardList setDesignsCount={setDesignsCount}/>

                </div>

            </div>

        </>
    )
}

export default DesignDashboard
